// extracted by mini-css-extract-plugin
export default {"root":"CkeckBox_root__KiEZH","textColor":"CkeckBox_textColor__xL9xR"};